import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactToolTip from 'react-tooltip';

const DashboardBoxes = (props) => {
    // console.log("props",props);
    const {data, result, loading} = props;
    
    
    let dataDisplay = "";
    if (("loading" in props) && (loading === true)){
        dataDisplay = <FontAwesomeIcon icon="circle-notch" spin />;
    }
    else{
        if ("result" in props){
            dataDisplay = result;
        }
        else{
            dataDisplay = data.mainText;
        }
    }


    return ( 
        <div className={ data.classes + " box flex"} style={{padding: "1rem 0.8rem"}}>
            <div className={"w-10 h-10 xl:w-12 xl:h-12 mr-3 flex-shrink-0 rounded-xl flex " + (data.iconBg ? data.iconBg : '') }>
                {data.icon ? data.icon : '' }
            </div>
            <div>
                <div className="text-xs font-semibold xl:mt-1 flex justify-between align-center" style={{color: "#6B7280"}}>
                    {data.titleText ? data.titleText : '' }

                    {props.dataTip && <span>
                        <FontAwesomeIcon data-tip data-for={props.id} icon='info-circle' className='ml-2 tip-icon text-ep-secondary'/>
                        <ReactToolTip id={props.id}> {props.id === 'noOfEmplyee' ? 
                            <span className='text-sm'>This is the number of employees <br/> you uploaded on Earnipay.</span>:
                            props.id === 'totalEnrolled' ? 
                            <span className='text-sm'>This is the number of your uploaded <br/> employees that have activated their <br/> account on Earnipay.</span> :
                            props.id=== 'totalWithdrawal' ? 
                            <span className='text-sm'>This is the amount of withdrawals done <br/> by your employees since your company <br/>joined Earnipay.</span> : 
                            props.id ==='withdrawn' ? <span className='text-sm'>This is the total value of withdrawals done <br/>by your employees since your company <br/> joined Earnipay.</span>: ''}
                        </ReactToolTip>
                        </span>}
                        
                </div>
                <div className="text-black text-xl font-semibold">
                    {dataDisplay}
                    {/* {("result" in props) ? result : data.mainText } */}
                </div>
                {data.subText1 || data.subText2 ? 
                    <div className="text-xs mt-1 text-gray-400 font-semibold">
                        {data.subText1 ? data.subText1 : '' }
                        {data.subText2 ? data.subText2 : '' }
                    </div>
                :''}
            </div>
        </div>
     );
}
 
export default DashboardBoxes;